// small hack to make category card prettier for safari 14.1 and earlier

export const CategoryCard = (target: HTMLAnchorElement) => {

  const el = {
    root: target,
    content: target.querySelector<HTMLDivElement>('.category-card__content'),
    svgContainer: target.querySelector<HTMLDivElement>('.category-card__logo'),
    svg: target.querySelector<HTMLDivElement>('.category-card__logo svg'),
    imageContainer: target.querySelector<HTMLDivElement>('.category-card__image'),
    img: target.querySelector<HTMLDivElement>('.category-card__image img'),
    text: target.querySelector<HTMLDivElement>('.category-card__title'),
    textWrapper: target.querySelector<HTMLDivElement>('.category-card__text-wrapper'),
  }

  const method = {
    init: () => {
      if (!el.content) return
      if (!el.text && !el.textWrapper) return
      if (!el.svgContainer && !el.imageContainer) return

      method.onResize()
      window.addEventListener('resize', method.onResize)
    },

    onResize: () => {
      try {
        const textElement = el.textWrapper || el.text
        const logoContainer = el.imageContainer || el.svgContainer
        const logo = el.img || el.svg

        logoContainer.style.height = ''
        logo.style.height = ''

        // main featured card should not have computed height on mobile
        const { innerWidth } = window
        if (el.root.classList.contains('category-card--main-featured') && innerWidth < 992) {
          logoContainer.style.height = ''
          logo.style.height = ''
          el.content.style.opacity = '1'
          return
        }

        const height = el.root.clientHeight
        const [paddingTop] = window.getComputedStyle(el.content, null).getPropertyValue('padding-top').split('px')
        const [paddingBottom] = window.getComputedStyle(el.content, null).getPropertyValue('padding-bottom').split('px')
        const [gap] = window.getComputedStyle(el.content, null).getPropertyValue('gap').split('px')

        const logoHeight = height - textElement.clientHeight - parseInt(paddingTop) - parseInt(paddingBottom) - parseInt(gap)

        logoContainer.style.height = `${logoHeight}px`
        logo.style.height = `${logoHeight}px`
      } catch (_) { /* */ }

      el.content.style.opacity = '1'
    },
  }

  method.init()
}
